import { Col, Row } from 'react-bootstrap';
import LocationList from '../components/admin/location/LocationList';
import AdminLayout from './layout/AdminLayout';

const ClientDetail = () => {

    return (
        <AdminLayout>
            <Row>
                <Col className='container'>
                    <LocationList />
                </Col>
            </Row>
        </AdminLayout>
    )
}

export default ClientDetail;